import Vue from "vue";

Vue.filter("checkIfArchiveCategory", function(itemData, archiveId)
{
    if (itemData == null)
    {
        return "";
    }

    var archiveClass = "";

    if (archiveId !== "")
    {
        archiveId = parseInt(archiveId);
        if (!isNaN(archiveId))
        {
            if (typeof (itemData.defaultCategories) !== "undefined")
            {
                var defaultCategories = itemData.defaultCategories;

                for (var i = 0; i < defaultCategories.length; i++)
                {

                    if (typeof (defaultCategories[i].parentCategoryId) !== "undefined" && defaultCategories[i].parentCategoryId === archiveId)
                    {
                        archiveClass = "archive";
                        break;
                    }
                    if (typeof (defaultCategories[i].id) !== "undefined" && defaultCategories[i].id === archiveId)
                    {
                        archiveClass = "archive";
                        break;
                    }
                }
            }
        }
    }

    return archiveClass;

});
